<template>
  <div class="mt-2">
    <table class="table b-table table-striped">
      <thead>
        <tr>
          <th colspan="2" class="text-center">
            {{ $t('operational_security.operational_processes.employee') }}
          </th>
        </tr>
        <tr>
          <th>{{ $t('operational_security.operational_processes.image') }}</th>
          <th>{{ $t('operational_security.operational_processes.name') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="employee in employees">
          <th style="width: 80px">
            <img
              v-if="employee.image"
              :src="employee.image ? employee.image.url : null"
              alt="Sin imagen"
              class="avatar"
            />
            <div v-else class="avatar d-flex align-items-center justify-content-center">
              <feather-icon icon="ImageIcon" size="20" class="align-middle text-body" />
            </div>
          </th>
          <td class="fw-bold">
            <span>{{ employee.employee_id }}</span>
            <p>{{ employee.first_name }} {{ employee.last_name }}</p>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    employees: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      slide: 0,
      sliding: false,
    };
  },
  methods: {
    onSlideStart() {
      this.sliding = true;
    },
    onSlideEnd() {
      this.sliding = false;
    },
  },
};
</script>

<style>
.avatar {
  height: 60px;
  width: 60px;
  border-radius: 50%;
  object-fit: cover;
}
</style>

